import Firebase from 'firebase';
import _ from 'lodash'
//import {AccessToken} from "react-native-fbsdk";
//TODO
import {strings, ActionTypes} from './../../cc-imports'

const FirebaseSignInUtils = {

    updateUserProfileData:(user,  newUser, callback)=>{
        var providerData = newUser.providerData;
        if(providerData && (newUser.photoURL==null||newUser.displayName==null)){
            var update = {};
            _.forEach(providerData,(sPData)=>{
                if((newUser.displayName==null || newUser.displayName==undefined) && sPData.displayName){
                    update.displayName = sPData.displayName;
                }
                if(newUser.photoURL==null && sPData.photoURL){
                    update.photoURL = sPData.photoURL;
                }
            });
            newUser.updateProfile(update).then(()=>{
                callback(newUser);
            }).catch(()=>{
                callback(newUser);
            });
        }
        else{
            callback(newUser);
        }
    },

    signIn:(credential, successCb, errorCb, actions) => {
        Firebase.auth().signInWithCredential(credential).then((user)=>{
            //TODO added as a temperory fix to the problem where user displayname and profileUrl not merged once we linkwithCredentials
            FirebaseSignInUtils.updateUserProfileData(null, user,successCb);
            //successCb(user);
        }).catch((err)=>{
            switch (err.code){
                case 'auth/account-exists-with-different-credential':
                    if(actions) actions.saveFailedCredentials(credential);
                    if(credential.providerId=='password' && credential.token){
                        Firebase.auth().fetchProvidersForEmail(credential.token).then((providers)=>{
                            errorCb(FirebaseSignInUtils.getFirebaseProviderError(providers));
                        }).catch((err)=>{
                            errorCb(strings('fire_base_wrong_message'));
                        });
                    }
                    else {
                        errorCb(strings('fire_base_already_login_different'))
                    }
                    break;
                case 'auth/wrong-password':
                    Firebase.auth().fetchProvidersForEmail(credential.token).then((providers)=>{
                        if(actions && providers && providers.length>0) actions.saveFailedCredentials(credential);
                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
                    }).catch((err)=>{
                        //errorCb(strings('fire_base_wrong_message'));
                    });
                    break;
                default:
                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
        })
    },
    signUp:(provider, successCb ,errorCb, actions )=>{
        Firebase.auth().currentUser && Firebase.auth().currentUser.linkWithPopup(provider).then((user)=>{
            //TODO added as a temperory fix to the problem where user displayname and profileUrl not merged once we linkwithCredentials
            FirebaseSignInUtils.updateUserProfileData(null, user,successCb);
            //successCb(user);
        }).catch((err)=>{
            var credential = err.credential;

            //TODO : this is to handle the facebook login not getting credential issue
            if(credential==undefined){
                errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
            switch (err.code){
                case 'auth/credential-already-in-use':
                    //console.log(Firebase.auth().AuthCredential);
                    FirebaseSignInUtils.signIn(credential,successCb, errorCb, actions);
                    break;
                case 'auth/email-already-in-use':
                    FirebaseSignInUtils.signIn(credential,successCb, errorCb, actions);
                    break;
                case 'auth/wrong-password':
                    //todo verify ( double check err.email and err )
                    Firebase.auth().fetchProvidersForEmail(err.email).then((providers)=>{
                        if(actions && providers && providers.length>0) actions.saveFailedCredentials(credential);
                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
                    }).catch((err)=>{
                        errorCb(strings('fire_base_wrong_message'));
                    });
                    break;
                default:
                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
        })
    },

    signOnFb: (provider, successCb, errorCb, actions)=>{
        FirebaseSignInUtils.signUp(provider,(user)=> {
            if(user.email==null||user.email==undefined) {
                var email = FirebaseSignInUtils._composeFBEmail(user);
                user.sendEmailVerification();
                FirebaseSignInUtils.updateEmail(email, ()=>{
                    //added to fix after updating email address, if we pass the returned user, the email is null and user not moving out of login screen
                    user = Firebase.auth().currentUser;
                    successCb(user);
                })
            }
            else {
                successCb(user);
            }
        }, errorCb, actions)
    },


    signOnGgl: (provider, successCb, errorCb, actions )=>{
        FirebaseSignInUtils.signUp(provider,successCb, errorCb, actions)
    },


    signInEmail: (user,  successCb, errorCb, actions)=>{
        var credential = Firebase.auth.EmailAuthProvider.credential(user.email, user.password);
        Firebase.auth().signInWithCredential(credential).then(function(newUser) {
            FirebaseSignInUtils.updateUserProfileData(user, newUser,successCb);
        }).catch(function(err) {
            switch (err.code){
                case 'auth/account-exists-with-different-credential':
                    if(actions) actions.saveFailedCredentials(credential);
                    if(credential.providerId=='password' && credential.token){
                        Firebase.auth().fetchProvidersForEmail(credential.token).then((providers)=>{
                            errorCb(FirebaseSignInUtils.getFirebaseProviderError(providers));
                        }).catch((err)=>{
                            errorCb(strings('fire_base_wrong_message'));
                        });
                    }
                    else {
                        errorCb(strings('fire_base_already_login_different'))
                    }
                    break;
                case 'auth/wrong-password':
                    Firebase.auth().fetchProvidersForEmail(credential.token).then((providers)=>{
                        if(actions && providers && providers.length>0) actions.saveFailedCredentials(credential);
                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
                    }).catch((err)=>{
                        //errorCb(strings('fire_base_wrong_message'));
                    });
                    break;
                default:
                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
        });

        /*//check if user exists for email signins to avoid users signup by clicking login
        Firebase.auth().fetchProvidersForEmail(user.email).then((providers)=>{
            if(providers && providers.length>0){
                FirebaseSignInUtils.signOnEmail(user,successCb,errorCb, actions);
            }
            else {
                errorCb(strings('can_t_find_account'));
            }
        }).catch((err)=>{
            errorCb(strings('can_t_find_account'));
        });*/

    },

    signUpEmail: (user, successCb, errorCb, actions)=>{
        var credential = Firebase.auth.EmailAuthProvider.credential(user.email, user.password);
        Firebase.auth().currentUser.linkAndRetrieveDataWithCredential(credential).then(function(usercred) {
            var newUser = usercred.user;
            FirebaseSignInUtils.updateUserProfileData( user, newUser,successCb);
        }, function(err) {
            var credential = err.credential;

            //TODO : this is to handle the facebook login not getting credential issue
            if(credential==undefined){
                errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
            switch (err.code){
                case 'auth/credential-already-in-use':
                    //console.log(Firebase.auth().AuthCredential);
                    FirebaseSignInUtils.signInEmail(credential,successCb, errorCb, actions);
                    break;
                case 'auth/email-already-in-use':
                    FirebaseSignInUtils.signInEmail(credential,successCb, errorCb, actions);
                    break;
                case 'auth/wrong-password':
                    //todo verify ( double check err.email and err )
                    Firebase.auth().fetchProvidersForEmail(err.email).then((providers)=>{
                        if(actions && providers && providers.length>0) actions.saveFailedCredentials(credential);
                        errorCb(FirebaseSignInUtils.getWrongPasswordError(providers));
                    }).catch((err)=>{
                        errorCb(strings('fire_base_wrong_message'));
                    });
                    break;
                default:
                    errorCb(FirebaseSignInUtils.getFirebaseError(err));
            }
        });
        /*
         FirebaseSignInUtils.signUp(credential,(fbUser)=>{
             if(fbUser.displayName==null || fbUser.displayName==undefined){
                 fbUser.updateProfile({
                     displayName: user.displayName
                 }).then(()=>{
                     fbUser.sendEmailVerification();
                     successCb(fbUser);
                 });
             }
             else {
                 successCb(fbUser);
             }
         }, errorCb, actions);*/
    },


    reAuthGgl:(idToken, callback, errorCb) =>{
        FirebaseSignInUtils.reAuth(Firebase.auth.GoogleAuthProvider.credential(idToken),callback,errorCb);

    },

    reAuthFb:(accessToken, callback, errorCb) =>{
        FirebaseSignInUtils.reAuth(Firebase.auth.FacebookAuthProvider.credential(accessToken),callback,errorCb);
    },


    reAuthEmail:(email, password, callback, errorCb) =>{
        FirebaseSignInUtils.reAuth(Firebase.auth.EmailAuthProvider.credential(email, password),callback,errorCb);
    },

    reAuth:(credential, callback, errorCb) =>{
        Firebase.auth().currentUser.reauthenticateWithCredential(credential).then((err)=>{
            callback && callback();
        }).catch(errorCb);
    },


    getFirebaseProviderError(providers){
        let providersStr = '';
        if (providers && providers.length>0) {
            providers.forEach((provider)=> {
                if (provider == 'google.com') {
                    providersStr = providersStr + ' google ';
                }
                else if (provider == 'facebook.com') {
                    providersStr = providersStr + ' facebook ';
                }
            });

            return strings('providers_str', {providersStr: providersStr});
        }
        else {
            return strings('fire_base_wrong_message')
        }
    },

    getWrongPasswordError(providers){
        let providersStr = '';
        if (providers && providers.length>0) {
            providers.forEach((provider)=> {
                if (provider == 'google.com') {
                    providersStr = providersStr + ' google ';
                }
                else if (provider == 'facebook.com') {
                    providersStr = providersStr + ' facebook ';
                }
            });
            return strings('providers_str_try_google', {providersStr: providersStr});
        }
        else {
            return strings('password_incorrect');
        }
    },

    getFirebaseError(error) {
        switch (error.code) {
            case 'auth/invalid-email':
                return strings('invalid_mail');
                break;
            case 'auth/weak-password':
                return  strings('weak_password');
                break;
            case 'auth/user-not-found':
                return strings('no_email_with_account');
                break;
            case 'auth/user-disabled':
                return strings('account_disabled');
                break;
            case 'auth/user-mismatch':
                return 'We already have different account for this email.'
                break;
            case 'auth/user-not-found':
                return 'Failed to authenticate you.'
                break;
            case 'auth/invalid-credential':
                return 'Your credentials are invalid'
                break;
            default:
                return strings('unknown_error');
                break;
        }
    },


    linkProviders: ( credentials ) => {
        try {
            var currentUser = Firebase.auth().currentUser;
            if (credentials.length>0) {
                _.forEach(credentials,function(credential){
                    credential && currentUser.linkWithCredential(credential).then((error) => {
                        //console.log(error);
                    });
                });
            }
        } catch (e) {
            //console.log(e);
        }
    },

    signOutFirebase: (user) => {
        Firebase.auth().signOut();
    },

    resendVerificationEmail(){
        Firebase.auth().currentUser.sendEmailVerification().then(()=>{
            /*Alert.alert(
                strings('mail_sent'),
                strings('verification_mail_sent', {email :Firebase.auth().currentUser.email}),
                [
                    {text: 'OK', onPress: () => {}},
                ],
                { cancelable: true }
            )*/
        });
    },

    _composeFBEmail: (currentUser) => {
        let providerData = currentUser.providerData;
        var fbProvider = _.find(providerData, (providerD)=>{return providerD.providerId=='facebook.com'});
        return fbProvider.uid+'@facebook.com';
    },
    updateEmailForFacebookUsers(email, callback){
        //this scenario will be reached only when user signup using facebook connected to no email
        /*AccessToken.getCurrentAccessToken().then(
            (data) => {
                var credential = Firebase.auth.FacebookAuthProvider.credential(data.accessToken);
                Firebase.auth().currentUser.reauthenticateWithCredential(credential).then((err)=>{
                    FirebaseSignInUtils.updateEmail(email,callback);
                })
            }
        );*/
    },
    updateEmail(email, callback){
        Firebase.auth().currentUser.updateEmail(email).then(()=>{
            Firebase.auth().currentUser.sendEmailVerification().then(() => {
                callback && callback();
            });
        }, (error)=>{
            callback(FirebaseSignInUtils.getFirebaseError(error));
        })
    },

    updateDisplayName(displayName){
        Firebase.auth().currentUser.updateProfile({
            displayName: displayName
        });
    }

};

export default FirebaseSignInUtils;


// WEBPACK FOOTER //
// ./src/app/lib/firebase/FirebaseSignInUtils.js